{"schemaVersion":1,"release":{"version":"1.1.12","build":174,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.12-174.dmg","sha256":"316c7e22c2cc07e6c0cd8d7918a456c7ea2d93db8ab142f677ec3603ff8bf3fe","size":286982227}}
